<si-toast *ngIf="showToast" [icon]="toastIconConfig" [content]="toastContent" toastId="toastId"></si-toast>
<div class="app-blocker" [hidden]="!blockApplication"></div>
<div class="spinnerContainer text-center" [hidden]="!applicationLoader">
  <div class="spinner-border spinnerCls" role="status"></div>
</div>
<router-outlet></router-outlet>
